<script setup>

const props = defineProps({
  activeTab:{
    type: Number,
    default: "null"
  },
  actionText: {
    type: String,
    default: "Next"
  },
  onSave: {
    type: Function,
    default: () => {}
  },
  onSettingsAction: {
    type: Function,
    default: () => {}
  },
  onAssignAction: {
    type: Function,
    default: () => {}
  },
  onCopyProgram: {
    type: Function,
    default: () => {}
  },
  onPreviewAction: {
    type: Function,
    default: () => {}
  },
  onWeblinkAction: {
    type: Function,
    default: () => {}
  },
  onTour: {
    type: Function,
    default: () => {}
  },
  onLogAction: {
    type: Function,
    default: () => {}
  },
  onBack: {
    type: Function,
    default: null
  }
});
</script>

<template>
  <div id="app" class="app-container">
    <div class="header">
      <div class="left-action">
        <div v-if="onBack" class="go-back" @click="onBack">
          <img src="@/assets/images/arrowLeft.svg" />
          <span>{{$t('programs_tab')}}</span>
        </div>
        <router-link v-else to="/programs">
          <div class="go-back">
            <img src="@/assets/images/arrowLeft.svg" />
            <span>{{$t('programs_tab')}}</span>
          </div>
        </router-link>
      </div>
      <div class="right-actions">
        <div class="action-button-group">
          <div class="action-button-item" @click="onLogAction">
            <img src="@/assets/images/logIconNewGrey.svg" alt="Settings" />
          </div>
          <div class="action-button-item" v-if="activeTab!==0" @click="onTour" >
            <img src="../../assets/images/productTourOutline.svg"/>
          </div>

          <div id="th-step-0" class="action-button-item" @click="onCopyProgram" >
            <img src="@/assets/images/copyOutline.svg" />
          </div>

          <div id="th-step-1" class="action-button-item" @click="onAssignAction">
            <img src="@/assets/images/testOutline.svg" alt="Assign Test" />
          </div>

          <div id="th-step-2" class="action-button-item" @click="onSettingsAction">
            <img src="@/assets/images/settingsOutline.svg" alt="Settings" />
          </div>

          <div class="action-button-item" @click="onWeblinkAction">
            <img src="@/assets/images/weblinkOutline.svg" alt="Web Link" />
          </div>


          <div id="th-step-3" class="action-button-item" @click="onPreviewAction">
            <img src="@/assets/images/play.svg" alt="Preview" />
            <span>{{$t('preview_title')}}</span>
          </div>
        </div>

        <div class="action-primary-button" id="th-step-4" @click="onSave">
          <span>{{actionText}}</span>
        </div>
      </div>
    </div>

    <div class="layout-container">
      <slot />
    </div>
    <v-tour name="myTour"></v-tour>
  </div>
</template>


<style scoped>
.app-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  background-color: #FCFCFD;
  overflow-y: auto;
}

.header {
  position: fixed;
  width: 100%;
  background-color: #FFFFFF;
  border-bottom: 1px solid #EAECF0;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 20px;
  padding-right: 20px;
}

.layout-container {
  width: 100%;
  padding-top: 64px;
  margin: 0;
}

.go-back {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 12px;
  font-family: euclid_medium, sans-serif;
  border-radius: 9px;
  cursor: pointer;
}

.go-back img {
  width: 16px;
  height: 16px;
}

.right-actions {
  display: flex;
  flex-direction: row;
  gap: 15px;
}

.right-actions span {
  font-family: euclid_medium, sans-serif;
  font-size: 12px;
}

.left-action a {
  color: #040C2D;
}

.left-action a:active {
  color: #040C2D;
}

.left-action a:visited {
  color: #040C2D;
}

.left-action a:hover {
  color: #040C2D;
}

.preview-link {
  cursor: pointer;
  color: #667085;
}


.header-action {
  cursor: pointer;
  height: 16px;
  width: 16px;
}
</style>
